export default function StatCard({
  title,
  value,
  icon
}) {

  return (

    <div className="stat-card">

      <div>

        <small>{title}</small>

        <h2>{value}</h2>

      </div>

      <div className="icon">

        {icon}

      </div>

    </div>

  );
}